// IE 2026 10 25 / ODOO-348925 (заказ Игоря: ERD-вид схемы): взаимное выделение «картинка ↔ гриды формы» для ERD-вида схемы (AttrSchemeGraphErd.vue) — КОПИЯ логики
// AttrSchemeGraphV2.vue (методы toGrid / pendWatch / applyPending / hookGrids / hook / unhook / fromGrid и utils sg2EdgeIndexOf / sg2GridPosOfEdge), вынесенная сюда,
// потому что в V2 она — методы компонента, а не экспорт (V2 в эту правку не трогается: её параллельно правит p035). Обобщено на любой набор гридов (which → имя грида)
// и ключ строки (keyFn). Поведение — как у V2: выбор из картинки — select + scrollIntoView строки грида (свёрнутых предков — navRow_reveal); грида нет / строк ещё нет /
// грид скрыт с отложенным обновлением (AttrGrid.gdr_busy) — выбор откладывается и применяется по loadedRows или опросом раз в 400 мс (до 5 мин); выбор пользователя
// в гриде (грид в фокусе) — в картинку; автовыбор wijmo при загрузке и наш select картинку не трогают.
import { toRaw } from 'vue'

const isObj = (v) => !!v && typeof v === 'object' && !Array.isArray(v)
const raw = (v) => { try { return toRaw(v) } catch (e) { return v } }

// строки грида по порядку (dataItem, без прокси)
export function sggItems(flex) {
    const items = []
    try { for (let r = 0; r < flex.rows.length; r++) { const it = flex.rows[r].dataItem; items.push(it ? raw(it) : null) } } catch (e) { /* грид в перестройке */ }
    return items
}
// индекс строки таблицы записи по строке грида: тот же объект; иначе — по ключу keyFn с тем же порядковым номером среди строк грида (как sg2EdgeIndexOf)
export function sggIndexOf(rows, item, keyFn, items) {
    if (!isObj(item) || !Array.isArray(rows)) return -1
    const i = rows.indexOf(item)
    if (i >= 0) return i
    const k = keyFn(item)
    if (!k || !k.split('\u0001').join('')) return -1
    const same = (Array.isArray(items) ? items : []).filter((it) => isObj(it) && keyFn(it) === k)
    const n = Math.max(0, same.indexOf(item))
    let seen = 0
    for (let j = 0; j < rows.length; j++) if (keyFn(rows[j]) === k) { if (seen === n) return j; seen++ }
    return -1
}
// позиция строки грида для строки таблицы записи с индексом index (как sg2GridPosOfEdge)
export function sggGridPosOf(items, rows, index, keyFn) {
    const row = Array.isArray(rows) ? rows[index] : null
    if (!isObj(row) || !Array.isArray(items)) return -1
    const i = items.indexOf(row)
    if (i >= 0) return i
    const k = keyFn(row)
    if (!k) return -1
    let n = 0
    for (let j = 0; j < index; j++) if (keyFn(rows[j]) === k) n++
    for (let j = 0, seen = 0; j < items.length; j++) if (isObj(items[j]) && keyFn(items[j]) === k) { if (seen === n) return j; seen++ }
    return -1
}
// позиция строки грида по ключу (первая с таким ключом)
export function sggPosOfKey(items, key, keyFn) {
    if (!key || !Array.isArray(items)) return -1
    for (let j = 0; j < items.length; j++) if (isObj(items[j]) && keyFn(items[j]) === key) return j
    return -1
}
const busy = (g) => { try { return !!(g && typeof g.gdr_busy === 'function' && g.gdr_busy()) } catch (e) { return false } }
const focused = (flex) => { try { return typeof document !== 'undefined' && !!flex.hostElement && flex.hostElement.contains(document.activeElement) } catch (e) { return false } }

// связка с гридами. host: { names: () => {which: имя грида}, widget: () => WIDGET, onPick(which, item, flex) — выбор пользователя в гриде, sel: () => текущее выделение,
// dead: () => компонент размонтирован, stats?: () => счётчики }. → { toGrid(which, findPos, late), hookAll(), unhookAll(), stop() }
export function sggLink(host) {
    const hooks = {}, pending = {}
    let pendT = 0, pendN = 0
    const S = () => (typeof host.stats === 'function' ? host.stats() : {})
    const nameOf = (which) => (host.names() || {})[which] || ''
    const gridVue = (which) => {
        try {
            const name = nameOf(which), W = host.widget()
            const v = name ? W?.vueObj?.get_vueObj?.(name) : null
            return v && v.flex ? v : null
        } catch (e) { return null }
    }
    const pendStop = () => { if (pendT) clearInterval(pendT); pendT = 0 }
    const pendWatch = () => {
        pendN = 0
        if (pendT) return
        pendT = setInterval(() => {
            if (host.dead() || !Object.keys(pending).length || ++pendN > 750) { pendStop(); return }
            hookAll()
        }, 400)
    }
    function toGrid(which, findPos, late) {
        if (!nameOf(which)) return false
        const g = gridVue(which), flex = g?.flex
        if (!flex?.rows || !flex.rows.length || busy(g)) { pending[which] = findPos; S().pending = (S().pending || 0) + 1; pendWatch(); return false }
        delete pending[which]
        const r = findPos(sggItems(flex))
        if (r < 0) return false
        try { g.navRow_reveal?.(r) } catch (e) { /* грид в перестройке */ }
        try { flex.select(r, Math.max(0, flex.selection?.col ?? 0)) } catch (e) { /* грид в перестройке */ }
        try { flex.scrollIntoView(r, 0) } catch (e) { /* грид в перестройке */ }
        S().gridPicks = (S().gridPicks || 0) + 1
        if (late) {
            const sel = host.sel()
            setTimeout(() => {
                if (host.dead() || host.sel() !== sel || flex.selection?.row === r) return
                if (focused(flex)) return   // пользователь уже в гриде — его выбор главнее
                try { flex.select(r, Math.max(0, flex.selection?.col ?? 0)); flex.scrollIntoView(r, 0) } catch (e) { /* грид в перестройке */ }
            }, 250)
        }
        return true
    }
    function applyPending(which) {
        const f = pending[which]
        if (!f) return
        const flex = gridVue(which)?.flex
        if (flex?.rows?.length) toGrid(which, f, true)
    }
    function unhook(which) {
        const x = hooks[which]
        if (x) try { x.flex.selectionChanged.removeHandler(x.h) } catch (e) { /* грид разрушен */ }
        if (x && x.lh) try { x.flex.loadedRows.removeHandler(x.lh) } catch (e) { /* грид разрушен */ }
        delete hooks[which]
    }
    function hook(which) {
        if (!nameOf(which)) return
        const flex = gridVue(which)?.flex
        if (!flex || hooks[which]?.flex === flex) return
        unhook(which)
        const h = (f) => {
            try {
                if (!focused(f)) return
                const r = f.selection?.row, it = r >= 0 ? f.rows[r]?.dataItem : null
                delete pending[which]   // выбор пользователя в гриде главнее отложенного из картинки
                host.onPick(which, it ? raw(it) : null, f)
            } catch (e) { /* грид разрушен */ }
        }
        const lh = () => { if (pending[which]) setTimeout(() => { if (!host.dead()) applyPending(which) }, 0) }
        try { flex.selectionChanged.addHandler(h); hooks[which] = { flex, h } } catch (e) { /* не wijmo */ }
        try { flex.loadedRows.addHandler(lh); if (hooks[which]) hooks[which].lh = lh } catch (e) { /* не wijmo */ }
    }
    function hookAll() { for (const which of Object.keys(host.names() || {})) { hook(which); applyPending(which) } }
    function unhookAll() { for (const which of Object.keys(hooks)) unhook(which) }
    function clearPending() { for (const k of Object.keys(pending)) delete pending[k]; pendStop() }
    return { toGrid, hookAll, unhookAll, clearPending, stop: () => { clearPending(); unhookAll() }, _pending: pending, _hooks: hooks }
}
